var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartIndicator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2299_10586)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7291 8.80948L11.2192 11.1904H8.27042L8.78063 8.80948H11.7291ZM3.47903 1.66663C1.83532 1.66663 1.66663 1.83487 1.66663 3.47857V16.5221C1.66663 18.1658 1.83532 18.3333 3.47903 18.3333H16.5225C18.1662 18.3333 18.3333 18.1658 18.3333 16.5221V3.47857C18.3333 1.83487 18.1662 1.66663 16.5225 1.66663H3.47903ZM8.93433 5.25139C9.25577 5.32027 9.46051 5.63669 9.39163 5.95814L9.03573 7.61901H11.9841L12.3932 5.70876C12.4621 5.38731 12.7785 5.18253 13.0999 5.25138C13.4214 5.32023 13.6261 5.63662 13.5573 5.95808L13.2016 7.61901H14.1666C14.4954 7.61901 14.7619 7.8855 14.7619 8.21425C14.7619 8.54299 14.4954 8.80948 14.1666 8.80948H12.9466L12.4366 11.1904H13.5714C13.9001 11.1904 14.1666 11.4569 14.1666 11.7857C14.1666 12.1144 13.9001 12.3809 13.5714 12.3809H12.1817L11.7726 14.2908C11.7037 14.6123 11.3874 14.8171 11.0659 14.7482C10.7444 14.6794 10.5397 14.363 10.6085 14.0415L10.9642 12.3809H8.01532L7.60592 14.2915C7.53704 14.6129 7.22062 14.8177 6.89917 14.7488C6.57773 14.6799 6.37299 14.3635 6.44187 14.042L6.79782 12.3809H5.83329C5.50455 12.3809 5.23805 12.1144 5.23805 11.7857C5.23805 11.4569 5.50455 11.1904 5.83329 11.1904H7.05292L7.56313 8.80948H6.42853C6.09979 8.80948 5.83329 8.54299 5.83329 8.21425C5.83329 7.8855 6.09979 7.61901 6.42853 7.61901H7.81823L8.22758 5.7087C8.29646 5.38725 8.61288 5.18251 8.93433 5.25139Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2299_10586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIndicator);
export default __webpack_public_path__ + "static/media/chart-indicator.c0dec332.svg";
export { ForwardRef as ReactComponent };